import { forwardRef, Inject, Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/map";
import { EnvironmentService } from "./index";

@Injectable()
export class AuthenticationService {
  public token: string;
  // new changes --  add here id for get dealer id
  public id: string;

  private host: String = environment.host;
  private port: String = environment.port;
  private authenticateUrl =
    this.environmentService.getBaseURL() + "/api/users/authenticate";

  constructor(
    private http: Http,
    @Inject(forwardRef(() => EnvironmentService))
    private environmentService: EnvironmentService
  ) {
    // set token if saved in local storage
    var currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.token = currentUser && currentUser.token;
    // new changes --  here id has assign of user id
    this.id = currentUser && currentUser._id;
  }

  login(email: string, password: string): Observable<boolean> {
    let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify({ email: email, password: password });
    //var emails = ["stig@micar.dk", "peter@micar.dk", "kundecenter@nellemann.dk", "morten@micar.dk", "flj@stromlin.com"];
    //if (emails.indexOf(email) < 0)
    //{
    //  throw new Error("Unauthorized");
    //}
    return this.http
      .post(this.authenticateUrl, body, options)
      .map((response: Response) => {
        if (response.status != 200) {
          throw new Error("Unauthorized");
        } else {
          let token = response.json() && response.json().token;
          let isadmin = response.json() && response.json().isadmin;
          let dealerid = response.json() && response.json().dealerid;
          let fullname = response.json() && response.json().fullname;
          let _id = response.json() && response.json()._id;
          // new changes --  here id has assign of user id
          this.id = response.json() && response.json()._id;
          if (token) {
            // set token property
            this.token = token;

            // store jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(
              "currentUser",
              JSON.stringify({
                token: token,
                isadmin: isadmin,
                fullname: fullname,
                dealerid: dealerid,
                _id: _id,
              })
            );

            // return true to indicate successful login
            return true;
          } else {
            // return false to indicate failed login
            throw new Error("Unauthorized");
          }
        }
      });
  }

  getToken(): string {
    return this.token;
  }
  // new changes --  here make function getId() for get userid in component
  getId(): string {
    return this.id;
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem("currentUser");
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts